/*
 * (c) Copyright, 2024, Medidata Solutions Worldwide, Inc. All rights reserved.
 */

import React, { useEffect, useRef, useState } from 'react'
import { useServiceContext } from '../../root'
import { RcmTableDataWrapper } from '../../components/rcm-table/RcmTableDataWrapper'
import { useGetAllFilteredNotifications } from '../../hooks/useNotifications'
import Table from './Table'
import PageMenu from './PageMenu'
import RcmTableFilterTrigger from '../../components/rcm-table/RcmTableFilterTrigger'
import TableFilter from './TableFilter'

const Notifications: React.FC = () => {
  const persistenceKey = 'notificationTable'
  const ref = useRef<HTMLDivElement>(null)
  const refreshTableRef = useRef<(() => void) | null>(null)

  const context = useServiceContext()
  const { translate } = context.service.filter

  const { mutateAsync: getAllFilteredMutation } = useGetAllFilteredNotifications()

  // Listen for broadcast events to refresh the table
  const [isStudyEosAdmin, setIsStudyEosAdmin] = useState(false)

  useEffect(() => {
    const featuresInfo = context.service.init.getFeaturesInfo()
    setIsStudyEosAdmin(!!(featuresInfo?.eosFeature?.show && context.service.auth.getRole() === 'STUDY_ADMIN'))

    const handleUpdateTable = () => {
      if (refreshTableRef.current) {
        refreshTableRef.current()
      }
    }

    window.addEventListener('bctable:updateTable', handleUpdateTable)
    window.addEventListener('updateNotifications', handleUpdateTable)

    return () => {
      window.removeEventListener('bctable:updateTable', handleUpdateTable)
      window.removeEventListener('updateNotifications', handleUpdateTable)
    }
  }, [context])

  const loadData = async (queryParams: any, filterParam: Record<string, any>) => {
    // Get filter from formRef if available, otherwise use the passed filter
    const filterData = (context.store as any)?.formRef?.values?.filter || filterParam

    const result = await getAllFilteredMutation({
      filter: filterData,
      meta: queryParams
    })

    return {
      elements: (result as any).elements || [],
      totalElements: (result as any).totalElements || 0,
      hasNextPage: (result as any).hasNextPage
    }
  }

  return (
    <div className="mcc-content-frame theme-sandman">
      <RcmTableDataWrapper
        loadData={loadData}
        defaultSortBy="timeCreated"
        defaultSortDesc={true}
        persistenceKey={persistenceKey}
        doPreload={true}
      >
        <div ref={ref}>
          <div className="sub-page-header">
            <div className="d-flex flex-wrap">
              <div className="align-left d-flex">
                <h1 id="7d5407fc-b709-49a6-8782-cbc09b03c1a9" style={{ fontWeight: 300 }}>
                  {translate('NOTIFICATIONS_TITLE')}
                </h1>
              </div>
              {!isStudyEosAdmin && <PageMenu />}
              <RcmTableFilterTrigger />
            </div>
          </div>
          <div>
            <TableFilter />
            <Table />
          </div>
        </div>
      </RcmTableDataWrapper>
    </div>
  )
}

export default Notifications
